// Импортируем полифиллы первыми, чтобы они были доступны для всего кода
// @babel/polyfill включает regenerator-runtime, но для надежности импортируем его явно
import '@babel/polyfill';
import 'regenerator-runtime/runtime';

import Vue from 'vue';
import VModal from 'vue-js-modal';
import Notifications from 'vue-notification';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import { WS_URL } from '@/config';
import VueCountdown from '@chenfengyuan/vue-countdown';
import VeeValidate from 'vee-validate';
import VueNativeSock from 'vue-native-websocket';
import IntersectionObserver from 'intersection-observer';
import Vuebar from 'vuebar';
import { i18n } from '@/plugins/i18n';
import firebaseService from '@/services/firebase.service';

Object.defineProperty(Vue.prototype, 'IntersectionObserver', { value: IntersectionObserver });

Vue.component(VueCountdown.name, VueCountdown);
Vue.use(VueNativeSock, WS_URL, {
    connectManually: true,
    passToStoreHandler: function (eventName, event) {
        let method = 'commit';
        let target = 'sockets/' + eventName.toUpperCase();
        let msg = event;
        if (this.format === 'json' && event.data) {
            msg = JSON.parse(event.data);
        }
        this.store[method](target, msg)
    },
    store: store,
    format: 'json',
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 3000
});
Vue.use(VModal, { dialog: true, dynamic: true, dynamicDefaults: { clickToClose: false } });
Vue.use(Notifications);
Vue.use(VeeValidate);
Vue.use(Vuebar);

if (!String.prototype.format) {
    String.prototype.format = function () {
        let args = arguments;
        return this.replace(
            /{(\d+)}/g,
            function (match, number) {
                return typeof args[number] != 'undefined' ? args[number] : match;
            }
        );
    };
}

new Vue({
    router,
    store,
    i18n,
    el: '#app',
    render: h => h(App)
});

